import api from './api';

export const listar = (page = 0, size = 20) =>
    api.get('/usuarios', { params: { page, size, sort: 'nomeCompleto' } }).then((r) => r.data);

export const criar = (dados) => api.post('/usuarios', dados).then((r) => r.data);

export const atualizar = (id, dados) => api.put(`/usuarios/${id}`, dados).then((r) => r.data);

export const remover = (id) => api.delete(`/usuarios/${id}`);

// A troca de senha encerra as sessões anteriores e o back devolve uma nova
// (cookie renovado + expiração), para quem trocou não ser deslogado na hora.
export const trocarSenha = (senhaAtual, novaSenha) =>
    api.put('/usuarios/senha', { senhaAtual, novaSenha }).then((r) => r.data);

export const listarSessoesDispositivo = () =>
    api.get('/sessoes/dispositivos').then((r) => r.data);

export const revogarSessaoDispositivo = (jti) =>
    api.post(`/sessoes/dispositivos/${jti}/revogar`);
